// View
import Form from '@views/Form'
import { FormField, FormStep } from '@views/Form'
import { validateUUID } from '@utils/helpers'

const config: Page.Config = {
  title: 'Claim Tracker',
  dataset: ['submission'],
  view: Form,
  content: {
    notice: () => {},
    wizard: (config: any, data: any) => ({
      onSubmit: data.getStatus,
      steps: [
        {
          id: 'step-0',
          entryPoint: true,
          submitPoint: true,
          component: FormStep,
          props: {
            submitting: data.submitting,
          },
          fieldIds: ['submissionId'],
        },
      ],
      fields: [
        {
          id: 'submissionId',
          component: FormField,
          props: {
            label: 'Claim Id',
            type: 'text',
            validationMsg: 'The claim id you have entered is not valid, please check and try again',
            placeholder: 'Enter your Claim Id, e.g. 1d1d1a1a-9c9c-2b2b-3c3c-1kd9837yfhdj',
          },
          required: true,
          validation: (fields: any, value: string) => validateUUID(value),
        },
      ],
    }),
  },
}

export default config
